import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { Tutorial } from '@app/models';

@Component({
    selector: 'tutorial-player-dialog',
    templateUrl: './tutorial-player-dialog.component.html',
    styleUrls: ['./tutorial-player-dialog.component.scss'],
    standalone: false
})
export class TutorialPlayerDialogComponent implements OnInit {
  tutorialToPlay: Tutorial;
  videoDetails = null;

  constructor(
    public dialogRef: MatDialogRef<TutorialPlayerDialogComponent>
  ) { }

  ngOnInit() {
    if (this.tutorialToPlay?.sourceType === 'video') {
      this.videoDetails = { url: this.tutorialToPlay?.sourcePath };
    }
  }


  close() {
    return this.dialogRef.close(null);
  }
}